import Track from './../domain/Track'

/**
 * Parse tracks from api to Track objects
 */
class TrackParser {
  /**
     * @param {Object[]} trackArray
     * @return {Track[]}
     */
  static parse (trackArray) {
    if (!trackArray || trackArray.length === 0) {
      return []
    }
    const res = []
    const firstSetNo = trackArray[0].set_no
    let hasMultipleSets = false
    for (const trackObj of trackArray) {
      if (trackObj.set_no !== firstSetNo) {
        hasMultipleSets = true
        break
      }
    }
    let playableCounter = 0
    for (const trackObj of trackArray) {
      const trackNumber = hasMultipleSets ? trackObj.set_no + '.' + trackObj.trackno : trackObj.trackno
      const title = trackObj.track_title
      const work = trackObj.work || null
      // try get sound Url
      const soundUrl = this.tryGetSoundUrl(trackObj)
      // convert playtime seconds to string
      const duration = this.formatDuration(trackObj.playtime_seconds)
      const songIndex = soundUrl ? playableCounter++ : null
      const track = new Track(trackNumber, title, work, soundUrl, duration, songIndex)
      res.push(track)
    }
    return res
  }

  /**
     * format seconds as 'h:mm:ss'
     * @param {number} seconds
     * @return {string}
     */
  static formatDuration (seconds) {
    if (!seconds || seconds < 0) {
      return '-'
    }
    const s = seconds % 60
    const m = ((seconds - s) / 60) % 60
    const h = (seconds - m * 60 - s) / 3600
    return h + ':' + ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2)
  }

  /**
     * try and get a soundurl for track or return null
     * @param {Object} trackObj
     * @return {string |null}
     */
  static tryGetSoundUrl (trackObj) {
    try {
      return trackObj.sounds[0].url
    } catch (e) {
      return null
    }
  }
}

export default TrackParser
